import { Component, HostBinding, Input } from '@angular/core'
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms'
import { ErrorStateMatcher } from '@angular/material/core'
import { FormFieldComponent } from '../form-field/form-field.component'

@Component({
  selector: 'bdg-text-area-field',
  templateUrl: './text-area-field.component.html',
  styleUrls: ['./text-area-field.component.scss'],
})
export class TextAreaFieldComponent extends FormFieldComponent implements ErrorStateMatcher {
  @HostBinding('style.display')
  private display = 'flex'

  @Input()
  maxLength = 5000

  @Input()
  showLength = true

  constructor() {
    super()
  }

  error() {
    return this.control && this.control.touched && this.control.errors?.error
  }

  isErrorState(_: FormControl, form: FormGroupDirective | NgForm): boolean {
    return this.error()
  }

  get matcher() {
    return this as ErrorStateMatcher
  }

  @Input() set disable(value: boolean) {
    if (value) {
      this.control.disable()
    } else {
      this.control.enable()
    }
  }

  get lengthText(): string {
    return `${this.control?.value?.length || 0} / ${this.maxLength}`
  }
}
